import React from 'react';
import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';

export const getErrorMessage = (error: unknown): string | ReactElement => {
  if (error instanceof Error) {
    // Handle standard Error objects
    return error.message;
  } else if (typeof error === 'string') {
    // Handle plain string errors
    return error;
  } else if (axios.isAxiosError(error)) {
    // Handle Axios errors
    if (error.response) {
      // Server responded with an error status code
      return (
        <FormattedMessage
          id="predict.server_error_status_data"
          defaultMessage="Server error: {status} - {data}"
          values={{ status: error.response.status, data: JSON.stringify(error.response.data) }}
        />
      );
    } else if (error.request) {
      // No response received (network error)
      return (
        <FormattedMessage
          id="predict.network_error_no_response"
          defaultMessage="Network error: No response received from the server."
        />
      );
    } else {
      // Axios configuration error or other issues
      return (
        <FormattedMessage
          id="predict.axios_error_message"
          defaultMessage="Axios error: {message}"
          values={{ message: error.message }}
        />
      );
    }
  } else {
    // Handle all other cases (e.g., numbers, objects, etc.)
    return JSON.stringify(error);
  }
};
